module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item.isbottle != 3) ? _c('a', {
    staticClass: "ui autoship-link",
    on: {
      "click": function($event) {
        return _vm.gotoAutoshipPage()
      }
    }
  }, [_c('img', {
    staticClass: "ui image tiny",
    attrs: {
      "src": require("../assets/autoship_logo-2.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.getAutoshipPrice(_vm.item)) + " €")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-756f7dda!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AutoShip.vue
// module id = 359
// module chunks = 1